export const swalModals = {
  data() {
    return{
      hasChanges:false
    }
  },
  methods: {
    swalUnsavedChanges() {
      return this.$swal({
        title: this.$root.$t('modal.changes.title'),
        text:  this.$root.$t('modal.changes.text'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText:  this.$root.$t('modal.changes.confirmButtonText'),
        cancelButtonText: this.$root.$t('modal.changes.cancelButtonText'),
        reverseButtons: true
      })
    },
    swalDelete(value) {
      return this.$swal({
        title: 'Weet je het zeker?',
        html: 'Wilt u <strong>' + value + '</strong> echt verwijderen? Dit proces kan niet ongedaan worden gemaakt',
        type: 'error',
        confirmButtonText: 'Verwijderen',
        showCancelButton: true,
        cancelButtonText: 'Annuleren',
        reverseButtons: true
      })
    }
  }
}